import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=3c07659d&scoped=true"
import script from "./CompanyPage.vue?vue&type=script&lang=ts"
export * from "./CompanyPage.vue?vue&type=script&lang=ts"
import style0 from "./CompanyPage.vue?vue&type=style&index=0&id=3c07659d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c07659d",
  null
  
)

export default component.exports